import React from "react";
import NavBar from "../../Layout/Navbar";
import Footer from "../../Layout/Footer";

const ExternalPages = (props) => {
    return (
        <React.Fragment>
            <div className="position-relative">
                <NavBar isDark={true} />
                {props.children}
                <div className="position-absolute bottom-0 w-100">
                    <Footer />
                </div>
            </div>
        </React.Fragment>
    );
};

export default ExternalPages;
